/*
 * @Author: liyxt
 * @Date: 2020-06-01 10:33:53
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 14:53:10
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginButton from 'bee-button';
import { getSysFieldid, getParentWindow, getTopWindow } from '@platform/api';
require('bee-button/build/Button.css');
require('./index.less');
//import $PE from '../../pe/pe.js';

export default class Button extends Component {
    render() {
        let { onClick, fieldid, is_arrow, colors = 'weishabushezhiyigemoren', className = '', tabIndex = '-1', ...others } = this.props,
            childContent = this.props.children;
        let { shape } = this.props;
        if (fieldid) {
            if (is_arrow) {
                fieldid = fieldid + '-arrow_btn';
            } else {
                fieldid = fieldid + '_btn';
            }
        }
        let classname = `${className} nc-button-wrapper button-${colors} ${shape == 'icon' ? 'bt-icon' : ''} `;
        return (
            <OriginButton
                fieldid={getSysFieldid(fieldid)}
                onClick={e => {
                    if (this.disabledFlag) {
                        return;
                    } else {
                        this.disabledFlag = true;
                    }

                    // 这里呢 当是弹窗内的确定取消按钮时  children 会是一个 react对象
                    // 所以这里需要判断下情况  modify by bbqin
                    let $target = e.target || e.currentTarget || {};
                    if (typeof childContent === 'string') {
                        window.actionName = childContent;
                    } else {
                        window.actionName = $target.innerText || (childContent && childContent[0] ? childContent[0] : '按钮内部没有内容') || childContent;
                    }
                    if (getTopWindow().proxyAction) {
                        getTopWindow().proxyAction(onClick, this, this.props.children)(e);
                    } else if (typeof onClick === 'function') {
                        onClick(e);
                        //$NCPE.proxy(onClick, this, this.props.children)(e);
                    }

                    setTimeout(() => {
                        this.disabledFlag = false;
                    }, 300);

                }}
                className={classname}
                tabIndex={tabIndex}
                {...others}
            />
        );
    }
}
